<template>
	<div class="pt-16 pl-16">
		<div class="pos-rela">
			<img :src="src" alt="" />
			<div class="yx-background-white radius-8 pos-abso" style="top: 300px; left: 50%; width: 400px; margin-left: -200px">
				<div class="pt-16 pb-16 pl-24 yx-color-text-primary font-h3-medium yx-border-bottom">高级套餐可使用，如需体验可联系客服</div>
				<div class="flex-row-align-center flex-center mt-24 mb-24">
					<div class="text-align-center">
						<img style="width: 200px" src="@/assets/public/customer-img.png" alt="" />
						<p class="font-h4-regular yx-color-text-primary mt-16">扫码添加客服体验高级功能</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'demoTem',
	props: {
		path: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			visible: true,
		};
	},
	computed: {
		src({ path }) {
			const img = {
				home: 'https://cdn.chaoyongbushou.com/wx/20250225/1740471766923-cooper-home.png',
				achievements: 'https://cdn.chaoyongbushou.com/wx/20250225/1740477252402-cooper-achievements.png',
				groupConf: 'https://cdn.chaoyongbushou.com/wx/20250226/1740538085176-cooper-groupConf.png',
				department: 'https://cdn.chaoyongbushou.com/wx/20250226/1740540220034-cooper-department.png',
				delegationhead: 'https://cdn.chaoyongbushou.com/wx/20250226/1740540379261-cooper-delegationhead.png',
				tobeClaime: 'https://cdn.chaoyongbushou.com/wx/20250226/1740541755367-cooper-tobeClaime.png',
				trusteeship: 'https://cdn.chaoyongbushou.com/wx/20250227/1740638749641-cooper-trusteeship.png',
				shopGroup: 'https://cdn.chaoyongbushou.com/wx/20250227/1740638901583-cooper-shopGroup.png',
				extenTecord: 'https://cdn.chaoyongbushou.com/wx/20250227/1740639038775-cooper-extenTecord.png',
				pallet: 'https://cdn.chaoyongbushou.com/wx/20250227/1740639148520-cooper-pallet.png',
				selectionDecoration: 'https://cdn.chaoyongbushou.com/wx/20250227/1740639588538-cooper-selectionDecoration.png',
				order: 'https://cdn.chaoyongbushou.com/wx/20250227/1740639709277-cooper-order.png',
				myTalent: 'https://cdn.chaoyongbushou.com/wx/20250227/1740642221577-cooper-myTalent.png',
				emphasisTalent: 'https://cdn.chaoyongbushou.com/wx/20250227/1740642221577-cooper-myTalent.png',
				groupSeas: 'https://cdn.chaoyongbushou.com/wx/20250227/1740644251943-cooper-groupSeas.png',
				contacts: 'https://cdn.chaoyongbushou.com/wx/20250227/1740644586140-cooper-contacts.png',
				clueSeas: 'https://cdn.chaoyongbushou.com/wx/20250227/1740644703248-cooper-clueSeas.png',
				newRuleManage: 'https://cdn.chaoyongbushou.com/wx/20250227/1740644831302-cooper-newRuleManage.png',
				tagManagement: 'https://cdn.chaoyongbushou.com/wx/20250227/1740644980807-cooper-tagManagement.png',
				promotion: 'https://cdn.chaoyongbushou.com/wx/20250306/1741246371674-cooper-promotion.png',
				myActivities: 'https://cdn.chaoyongbushou.com/wx/20250227/1740645729530-cooper-myActivities.png',
				colonelActivitySquare: 'https://cdn.chaoyongbushou.com/wx/20250227/1740645820371-cooper-colonelActivitySquare.png',
				cooperativeColonel: 'https://cdn.chaoyongbushou.com/wx/20250227/1740645924433-cooper-cooperativeColonel.png',
				rulesSetting: 'https://cdn.chaoyongbushou.com/wx/20250227/1740646037679-cooper-rulesSetting.png',
				ruleManage: 'https://cdn.chaoyongbushou.com/wx/20250227/1740646192663-cooper-rulesSetting.png',
				newRuleManage: 'https://cdn.chaoyongbushou.com/wx/20250227/1740646192663-cooper-rulesSetting.png',
				tagManage: 'https://cdn.chaoyongbushou.com/wx/20250227/1740646421108-cooper-tagManage.png',
				message: 'https://cdn.chaoyongbushou.com/wx/20250227/1740646495778-cooper-message.png',
				talentObtain: 'https://cdn.chaoyongbushou.com/wx/20250227/1740646560760-cooper-talentObtain.png',
				cooperationProgress: 'https://cdn.chaoyongbushou.com/wx/20250227/1740646652719-cooper-cooperationProgress.png',
				local: 'https://cdn.chaoyongbushou.com/wx/20250227/1740646751980-cooper-libray.png',
			};
			return img[path];
		},
	},
};
</script>

<style scoped lang="less"></style>
